import "../scss/app.scss";
import { Tooltip, Popover } from "bootstrap";

// Permet de faire des foreach sur les éléments NodeList.
NodeList.prototype.forEach = Array.prototype.forEach;

document.addEventListener("DOMContentLoaded", function () {
  // Pour activer les tooltips et popover sur la page.
  const popoverTriggerList = [].slice.call(document.querySelectorAll("[data-bs-toggle=\"popover\"]")),
        tooltipTriggerList = [].slice.call(document.querySelectorAll("[data-bs-toggle=\"tooltip\"]"));

  popoverTriggerList.map((popoverTriggerEl) => new Popover(popoverTriggerEl));
  tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
});
